import { useMemo } from "react";

const roundAmount = (amount) => {
  if (!amount) return "";

  let temp = amount;

  if (typeof amount !== "number") temp = parseInt(amount);

  return Math.round(temp).toLocaleString("id-ID");
};

const ListActiveUser = ({ data }) => {
  const ListActiveUser = useMemo(() => {
    const users = data?.subscription_invoice;

    const ListActiveUser = users?.charged_users?.map((user) => {
      return {
        idUser: user?.id,
        namaMarketing: user?.full_name,
        personalCommission: `Rp ${roundAmount(user?.amount)}`,
      };
    });

    let result = {
      jumlahMarketing: users?.charged_users?.length || 0,
      marketing: ListActiveUser,
      activeUser: users?.charged_users,
    };

    return result;
  }, [data]);

  return (
    <div className="px-6 pt-6 mt-6 border-t border-dashed border-[#D8D8D9] pb-2">
      <p className="text-[17px] leading-[26.6px] tracking-[-0.4px] font-semibold">
        Daftar User Aktif
      </p>
      <p className="mb-2 text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
        Jumlah User:{" "}
        <span className="text-[#252526]">{ListActiveUser?.activeUser?.length || 0}</span>
      </p>

      <div>
        <div className="grid grid-cols-[80px_repeat(5,1fr)] px-4 py-2 bg-[#F5F5F5]">
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            ID User
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285]">
            Nama Marketing
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Role
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Nomor Telepon
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Alamat Email
          </p>
          <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#808285] text-end">
            Status
          </p>
        </div>
        {!!ListActiveUser?.activeUser?.length &&
          ListActiveUser.activeUser.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-[80px_repeat(5,1fr)] px-4 py-2 border-b-[0.5px] border-solid border-[#D8D8D9] last:border-none"
            >
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
                {item.id}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526]">
                {item.full_name}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                {item.role_name}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                {item.phone}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                {item.email}
              </p>
              <p className="text-[13px] leading-[21.034px] tracking-[-0.4px] text-[#252526] text-end">
                {item.status}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ListActiveUser;
